var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"platform-container"},[_c('div',{staticClass:"back-area",on:{"click":_vm.goBack}}),_c('div',{staticClass:"switch-area",on:{"click":_vm.switchImage}}),_c('img',{staticClass:"platform-image",attrs:{"src":_vm.currentImage,"alt":"朝阳区人事考试智能指挥调度一体化平台"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }